import { render, staticRenderFns } from "./contacts.vue?vue&type=template&id=7743074a&"
import script from "./contacts.vue?vue&type=script&lang=ts&"
export * from "./contacts.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports